import { QueryFunctionContext } from '@tanstack/react-query';
import { WebhookEntityParams, WebhookEntityResponse } from './flow.types';
import { apiClient } from '@store/index';

export const getWebhookEntity = async ({
  queryKey,
}: QueryFunctionContext<[string, WebhookEntityParams]>): Promise<WebhookEntityResponse> => {
  const [, { service_id, workflow_id, profile_id, type, v1_secret }] = queryKey;

  let url = `/${service_id}/workflows/${workflow_id}/entity/${profile_id}?type=${type}`;
  if (v1_secret) url += `&v1_secret=${v1_secret}`;
  const response = await apiClient.get(url);

  if (response?.data === null) return null;
  if (response.data.error) {
    throw new Error(response.data.error);
  }

  if (!response.data) return null;

  const webhookEntity = response.data as WebhookEntityResponse;
  return webhookEntity;
};
